import GoogleAnalytics from 'react-ga';
import GoogleAnalyticsGa4 from 'react-ga4';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const setGoogleAnalytics = (forAdmin: boolean, theme: ApplicationMuiTheme, uiEnvLevel: string) => {
    const analyticsProp = forAdmin ? 'admin' : 'client';
    const ANALYTICS_INTERESTS = [
        {
            trackingId: 'UA-126044816-1', // TDH ID
            gaOptions: {
                name: 'TDH',
                siteSpeedSampleRate: 100
            }
        }
    ];
    const GA4_ANALYTICS = [];

    if (theme?.app.google?.[analyticsProp]) {
        const analytics = (theme?.app.google?.[analyticsProp] || []).reduce((acc, obj) => {
            if (obj.environment && uiEnvLevel && uiEnvLevel.includes(obj.environment)) {
                if (obj.trackingId.slice(0, 3) === 'UA-') {
                    acc.ga.push({
                        trackingId: obj.trackingId,
                        gaOptions: {
                            name: obj.trackingName,
                            siteSpeedSampleRate: 100
                        }
                    });

                    return acc;
                }

                acc.ga4.push({
                    trackingId: obj.trackingId,
                    gaOptions: {
                        name: obj.trackingName,
                        siteSpeedSampleRate: 100
                    }
                    // gtagOptions: {
                    //     name: obj.trackingName,
                    //     siteSpeedSampleRate: 100,
                    //     debug_mode: true
                    // }
                });
            }

            return acc;
        }, {
            ga: [],
            ga4: []
        });
        ANALYTICS_INTERESTS.push(...analytics.ga);
        GA4_ANALYTICS.push(...analytics.ga4);
    }

    if (ANALYTICS_INTERESTS.length > 0) {
        GoogleAnalytics.initialize(ANALYTICS_INTERESTS, { alwaysSendToDefaultTracker: true });
    }
    if (GA4_ANALYTICS.length > 0) {
        GoogleAnalyticsGa4.initialize(GA4_ANALYTICS);
    }
};